import { JSX } from "react";

import { IconProps } from "@/@types/general.ts";
import { cn } from "@/utils/cn.ts";

interface IconRadioProps extends IconProps {
  active?: boolean;
}

const IconRadio = ({ color, active, ...otherProps }: IconRadioProps): JSX.Element => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 21 20" fill="none" {...otherProps}>
    <circle cx="10.5" cy="10" r="9" stroke={color} strokeWidth="2" className={"transition"} />
    <circle
      cx="10.5"
      cy="10"
      r="6"
      fill={color}
      className={cn("transition-opacity", {
        "opacity-0": !active,
        "opacity-100": active,
      })}
    />
  </svg>
);

export default IconRadio;
